import { jsx as _jsx } from "react/jsx-runtime";
import tokenData from '../../design-tokens/base-tokens.json';
import { ChevronDown as ChevronDownIcon } from 'mdi-material-ui';
export const MuiOutlinedInput = {
    defaultProps: {
        notched: false
    },
    styleOverrides: {
        root: ({ theme }) => ({
            '&.MuiOutlinedInput-root': {
                '&& .MuiAutocomplete-endAdornment': {
                    right: 8
                }
            },
            color: tokenData.tokens.palette.text.text300,
            boxSizing: 'border-box',
            '&:hover': {
                borderColor: tokenData.tokens.palette.blue.blue500
            },
            '&.Mui-focused': {
                color: tokenData.tokens.palette.text.text300,
                boxShadow: '0px 0px 0px 2px rgba(16, 116, 195, 0.59)',
                '& .MuiOutlinedInput-notchedOutline': {
                    border: `1px solid ${tokenData.tokens.palette.blue.blue500}`
                },
                '& .MuiNativeSelect-select': {
                    color: tokenData.tokens.palette.text.text300,
                    backgroundColor: tokenData.tokens.palette.background.white
                }
            },
            '&.Mui-error': {
                boxShadow: '0px 0px 0px 2px rgba(196, 32, 20, 0.5)',
                '& .MuiOutlinedInput-notchedOutline': {
                    border: `1px solid ${tokenData.tokens.palette.red.red600}`
                }
            },
            '& .MuiSvgIcon-root': {
                color: tokenData.tokens.palette.text.text100
            },
            '& .MuiSvgIcon-colorDisabled': {
                color: tokenData.tokens.palette.grey.disabled
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: tokenData.tokens.palette.grey.grey600
            },
            '&:hover:not(.Mui-disabled)': {
                color: tokenData.tokens.palette.text.text300,
                ':not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
                    borderColor: tokenData.tokens.palette.blue.blue500
                },
                '& .MuiSvgIcon-root': {
                    color: 'tokenData.tokens.palette.text.text300'
                }
            },
            '&.Mui-disabled': {
                backgroundColor: tokenData.tokens.palette.grey.grey100,
                pointerEvents: 'unset',
                cursor: 'not-allowed',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: tokenData.tokens.palette.grey.disabled
                },
                '& .MuiSvgIcon-root': {
                    color: tokenData.tokens.palette.grey.disabled
                },
                '& .MuiOutlinedInput-input': {
                    WebkitTextFillColor: tokenData.tokens.palette.text.text300,
                    color: tokenData.tokens.palette.text.text300
                }
            },
            '& .MuiNativeSelect-select': {
                padding: theme.spacing(2, 4),
                color: tokenData.tokens.palette.text.text100,
                backgroundColor: tokenData.tokens.palette.background.white,
                '&:hover:not(.Mui-disabled)': {
                    color: tokenData.tokens.palette.text.text300,
                    ':not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
                        borderColor: tokenData.tokens.palette.blue.blue500
                    }
                },
                '&.Mui-focused': {
                    '& .MuiSvgIcon-root': {
                        color: tokenData.tokens.palette.text.text300
                    }
                }
            }
        }),
        input: {
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
            '&.MuiInputBase-inputAdornedStart': {
                paddingLeft: '4px'
            },
            '&.MuiInputBase-inputMultiline': {
                paddingLeft: '0px'
            },
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.text.text300,
                WebkitTextFillColor: tokenData.tokens.palette.text.text300,
                pointerEvents: 'unset',
                cursor: 'not-allowed'
            }
        },
        adornedStart: {
            paddingLeft: '4px'
        },
        adornedEnd: {
            paddingRight: '4px'
        },
        multiline: {
            padding: '8px'
        }
    }
};
export const MuiTextField = {
    defaultProps: {
        size: 'small',
        InputLabelProps: { shrink: false },
        variant: 'outlined'
    },
    styleOverrides: {
        root: ({ theme }) => ({
            backgroundColor: tokenData.tokens.palette.background.white,
            '& .MuiOutlinedInput-root': {
                ...theme.typography.body1,
                color: tokenData.tokens.palette.text.text300,
                boxSizing: 'border-box',
                '& > fieldset': {
                    border: `1px solid ${tokenData.tokens.palette.grey.grey400}`
                },
                '&.Mui-focused': {
                    borderColor: tokenData.tokens.palette.blue.blue500,
                    boxShadow: '0px 0px 0px 2px rgba(16, 116, 195, 0.59)',
                    '& > fieldset': {
                        border: `1px solid ${tokenData.tokens.palette.blue.blue500}`
                    }
                },
                '&.Mui-disabled': {
                    backgroundColor: tokenData.tokens.palette.grey.grey100,
                    '& > fieldset': {
                        borderColor: tokenData.tokens.palette.grey.disabled
                    }
                },
                '&.Mui-error': {
                    borderColor: tokenData.tokens.palette.red.red600,
                    boxShadow: '0px 0px 0px 2px rgba(196, 32, 20, 0.5)',
                    '& > fieldset': {
                        border: `1px solid ${tokenData.tokens.palette.red.red600}`
                    }
                },
                '&:hover:not(.Mui-disabled):not(.Mui-error)': {
                    '& > fieldset': {
                        borderColor: tokenData.tokens.palette.blue.blue500
                    }
                },
                '& .MuiOutlinedInput-input': {
                    '&::placeholder': {
                        color: tokenData.tokens.palette.text.text100,
                        opacity: 1
                    },
                    '&.Mui-disabled': {
                        color: tokenData.tokens.palette.text.text300,
                        WebkitTextFillColor: tokenData.tokens.palette.text.text300
                    }
                },
                '& .MuiSvgIcon-root': {
                    color: tokenData.tokens.palette.text.text100
                },
                '& .MuiSvgIcon-colorDisabled': {
                    color: tokenData.tokens.palette.grey.disabled
                },
                '&.MuiInputBase-adornedStart': {
                    paddingLeft: '4px',
                    '& .MuiOutlinedInput-input': {
                        paddingLeft: '4px'
                    }
                },
                '&.MuiInputBase-adornedEnd .MuiInputAdornment-positionEnd': {
                    paddingRight: '4px',
                    marginLeft: 0,
                    '& .MuiOutlinedInput-input': {
                        paddingRight: '4px'
                    },
                    '& .MuiIconButton-root': {
                        marginRight: '-4px'
                    }
                },
                '& .MuiAutocomplete-input': {
                    padding: 4
                }
            },
            '& .MuiOutlinedInput-input': {
                padding: theme.spacing(2, 4),
                ...theme.typography.body1,
                height: 'auto'
            },
            '& .MuiInputBase-multiline': {
                padding: 0,
                '& .MuiOutlinedInput-input': {
                    padding: '8px'
                }
            },
            '& .MuiSelect-select': {
                color: tokenData.tokens.palette.text.text100,
                '&:hover:not(.Mui-disabled)': {
                    color: tokenData.tokens.palette.text.text300,
                    ':not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
                        borderColor: tokenData.tokens.palette.blue.blue500
                    },
                    '& .MuiSvgIcon-root': {
                        color: tokenData.tokens.palette.text.text300
                    }
                }
            },
            '& .MuiInputLabel-root': {
                marginBottom: '4px'
            }
        })
    }
};
export const MuiAutocomplete = {
    defaultProps: {
        popupIcon: _jsx(ChevronDownIcon, {}),
        size: 'small'
    },
    styleOverrides: {
        root: ({ theme }) => ({
            '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                '&.MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                    padding: theme.spacing(2, 4),
                    paddingRight: 48,
                    '& .MuiAutocomplete-input': {
                        padding: 0,
                        ...theme.typography.body1
                    }
                }
            },
            color: tokenData.tokens.palette.text.text300,
            backgroundColor: tokenData.tokens.palette.background.white,
            '&.MuiOutlinedInput.MuiInputBase-sizeSmall': {
                padding: theme.spacing(1)
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderRadius: 6
            },
            '& .MuiOutlinedInput-root': {
                padding: theme.spacing(2),
                '& .MuiAutocomplete-input': {
                    padding: theme.spacing(2)
                },
                '&.MuiInputBase-adornedStart': {
                    paddingLeft: theme.spacing(2)
                },
                '&.MuiInputBase-adornedEnd': {
                    paddingRight: theme.spacing(2)
                }
            },
            '& .MuiAutocomplete-input': {
                padding: theme.spacing(2),
                height: 'auto'
            },
            '& .MuiTextField-root': {
                '& .MuiOutlinedInput-input': {
                    padding: theme.spacing(2)
                },
                '& .MuiAutocomplete-input': {
                    minWidth: 80
                }
            },
            '& .MuiInputAdornment-positionStart': {
                '& .MuiOutlinedInput-root': {
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    paddingRight: 0,
                    '&.MuiAutocomplete-hasPopupIcon': {
                        paddingRight: theme.spacing(50)
                    },
                    '&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon': {
                        paddingRight: 0
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: tokenData.tokens.palette.grey.grey600,
                        borderTop: 'none',
                        borderBottom: 'none',
                        borderLeft: 'none',
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    }
                },
                '&.MuiInputAdornment-root': {
                    marginRight: 4
                },
                '& .MuiSelect-select': {
                    paddingRight: theme.spacing(16)
                }
            },
            '& .MuiInputAdornment-positionEnd': {
                position: 'absolute',
                right: 0,
                height: '100%',
                '& .MuiCircularProgress-root': {
                    marginRight: 8
                },
                '& .MuiButton-contained': {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    height: '100%'
                },
                '& .MuiOutlinedInput-root': {
                    paddingRight: theme.spacing(20)
                }
            },
            '& .MuiSelect-select': {
                paddingRight: theme.spacing(20),
                '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none !important'
                }
            },
            '& .MuiAutocomplete-tag': {
                margin: 0,
                marginRight: 4
            }
        }),
        input: {
            padding: 0
        },
        inputRoot: {
            rowGap: 4
        },
        groupUl: {
            '& .MuiAutocomplete-option': {
                paddingLeft: 16
            }
        }
    }
};
export const MuiSelect = {
    defaultProps: {
        IconComponent: ChevronDownIcon,
        size: 'small'
    },
    styleOverrides: {
        root: {
            color: tokenData.tokens.palette.text.text200,
            backgroundColor: tokenData.tokens.palette.background.white,
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: tokenData.tokens.palette.grey.grey400
            },
            '&:hover:not(.Mui-disabled)': {
                color: tokenData.tokens.palette.text.text300,
                ':not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
                    borderColor: tokenData.tokens.palette.blue.blue500
                },
                '& .MuiSvgIcon-root': {
                    color: tokenData.tokens.palette.text.text300
                }
            },
            '&.Mui-focused': {
                color: tokenData.tokens.palette.text.text300,
                boxShadow: '0px 0px 0px 2px rgba(16, 116, 195, 0.59)',
                '& .MuiOutlinedInput-notchedOutline': {
                    border: `1px solid ${tokenData.tokens.palette.blue.blue500}`
                },
                '& .MuiSvgIcon-root': {
                    color: tokenData.tokens.palette.text.text300
                }
            },
            '&.Mui-error': {
                borderColor: tokenData.tokens.palette.red.red600,
                boxShadow: '0px 0px 0px 2px rgba(196, 32, 20, 0.5)',
                '& .MuiOutlinedInput-notchedOutline': {
                    border: `1px solid ${tokenData.tokens.palette.red.red600}`
                }
            },
            '&.Mui-disabled': {
                backgroundColor: tokenData.tokens.palette.grey.grey100,
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: tokenData.tokens.palette.grey.disabled
                },
                '& .MuiSvgIcon-root': {
                    color: tokenData.tokens.palette.grey.disabled
                },
                '& .MuiOutlinedInput-input': {
                    WebkitTextFillColor: tokenData.tokens.palette.text.text300,
                    color: tokenData.tokens.palette.text.text300
                }
            },
            //TODO: Come back to this as it breaks autocompletes next to selects but also breaks the composite component when both are needed together
            // '& + .MuiAutocomplete-root': {
            //     '& .MuiOutlinedInput-root': {
            //         borderTopLeftRadius: 0,
            //         borderBottomLeftRadius: 0,
            //         zIndex: 1,
            //         '&:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error)': {
            //             '& .MuiOutlinedInput-notchedOutline': {
            //                 borderLeft: 'none'
            //             }
            //         }
            //     }
            // },
            '&.MuiInputBase-adornedStart': {
                paddingLeft: 0,
                '& .MuiSelect-select': {
                    paddingLeft: 32
                },
                '& .MuiSvgIcon-root:first-of-type': {
                    pointerEvents: 'none',
                    position: 'absolute',
                    left: 8
                }
            }
        },
        icon: {
            color: tokenData.tokens.palette.text.text100
        },
        select: ({ theme }) => ({
            padding: theme.spacing(2, 4),
            minHeight: 'auto',
            ...theme.typography.body1,
            '&:hover:not(.Mui-disabled)': {
                color: tokenData.tokens.palette.text.text300
            },
            '&.Mui-focused': {
                color: tokenData.tokens.palette.text.text300
            }
        }),
        multiple: {
            color: tokenData.tokens.palette.text.text100
        }
    }
};
export const MuiNativeSelect = {
    defaultProps: {
        size: 'small',
        IconComponent: ChevronDownIcon
    },
    styleOverrides: {
        select: {
            backgroundColor: tokenData.tokens.palette.background.white
        },
        icon: {
            color: tokenData.tokens.palette.text.text100
        }
    }
};
